import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { GUEST_RESERVE_SERVICE_STEP } from 'constants/reservation';
import AprosButton from 'components/aprosButton/index';
import StepperGuest from 'components/stepperGuest/index';
import Linked from 'components/linked/index';
import Proctitle from 'components/proctitle/index';
import Icons from 'images/icons';
import Checkbox from 'components/checkbox/index';
import dayjs from 'dayjs';
import axios from 'utils/axiosUtil';
import { GUEST_RESERVE_CREATE } from 'constants/apiURL';
import ModalBase from 'components/modalBase/index';
import Path, { ERROR_MESSAGE_TRANSITION } from 'constants/routePath';
import { useDispatch } from 'react-redux';
import { messageModalActions } from 'slices/messageModalSlice';
import { getTermKbn } from 'utils/otherUtil';
import Title from '../../constants/title';
import { Helmet } from 'react-helmet';

const GuestConfirm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const carInfo = location.state?.carInfo || {};
  const userInfo = location.state?.userInfo || {};
  const shopAndDateInfo = location.state?.shopAndDateInfo || {};
  const [isTermsChecked, setIsTermsChecked] = useState(false);
  const [error, setError] = useState(null);
  const [isBottomVisible, setIsBottomVisible] = useState(true);

  const CHUBUN_CD = '021';
  const SHOBUN_CD = ['101'];
  const SGY_SEQ = '01';

  useEffect(() => {
    if (
      !location.state?.userInfo ||
      !location.state?.carInfo ||
      !location.state?.shopAndDateInfo
    ) {
      const message = ERROR_MESSAGE_TRANSITION;
      dispatch(messageModalActions.showMessageModal({ message }));
      navigate(Path.GUEST_RESERVATION);
      return;
    }
  }, [location.state, navigate]);

  // ゲスト予約情報反映API呼び出し
  const handleReserve = async () => {
    setError(null);
    const shopAndDateInfo = location.state?.shopAndDateInfo || {};
    const carInfo = location.state?.carInfo || {};
    const userInfo = location.state?.userInfo || {};
    const requiredTime = location.state?.requiredTime || 0;

    const sgyStaHm = dayjs(shopAndDateInfo.time, 'HH:mm').format('HHmm');
    const sgyEndHm = dayjs(shopAndDateInfo.time, 'HH:mm')
      .add(requiredTime, 'minute')
      .format('HHmm');

    const response = await axios.post(`${GUEST_RESERVE_CREATE}`, {
      termKbn: getTermKbn(),
      shopCode: shopAndDateInfo?.shop?.shopCode,
      sgyYmd: shopAndDateInfo.date.replace(/[^0-9]/g, ''),
      sgyStaHm: sgyStaHm,
      sgyEndHm: sgyEndHm,
      chubunCd: CHUBUN_CD,
      shobunCd: SHOBUN_CD,
      sgySeq: SGY_SEQ,
      simei: `${userInfo?.lastName}${userInfo?.firstName}`,
      simeiKna: `${userInfo?.lastNameKana}${userInfo?.firstNameKana}`,
      telNo: userInfo?.phoneNumber,
      mailAdr: userInfo?.email,
      sryMkrCd: carInfo?.manufacturerCode,
      sryMkrMei: carInfo?.manufacturer,
      sshCd: carInfo?.carModelCode,
      sryKshCd: carInfo?.carNameCode,
      sshMei: carInfo?.carModel,
      sryNnskYm: carInfo?.year,
      sokKyrKm: carInfo?.mileage,
    });

    navigate(Path.GUEST_COMPLETE, {
      state: {
        ...location.state,
        reservationResponse: response,
      },
    });
  };

  const scrollToBottom = () => {
    const caution = document.querySelector('#caution');

    document.getElementById('root').scrollTo({
      top: caution.offsetTop - 20,
      behavior: 'smooth',
    });
  };

  let confirmbottom = null;

  const handleScroll = () => {
    if (isInDisplay()) {
      setIsBottomVisible(false);
    } else {
      setIsBottomVisible(true);
    }
  };

  const isInDisplay = () => {
    if (!confirmbottom) return false;
    const { top, bottom } = confirmbottom.getBoundingClientRect();
    return top >= 0 && bottom <= window.innerHeight;
  };

  useEffect(() => {
    confirmbottom = document.querySelector('#confirmbottom');
    document.getElementById('root').addEventListener('scroll', handleScroll);
    return () => {
      document.getElementById('root').removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="mt-4 lg:px-20">
      <Helmet>
        <title>{Title.GUEST_RESERVATION}</title>
      </Helmet>
      <StepperGuest
        labels={GUEST_RESERVE_SERVICE_STEP}
        previousStep={location.state?.previousStep}
        activeStep={3}
        fullWidth={true}
        className={{
          stepperClass: 'mb-10 max-sm:mx-8 sm:mx-36',
          bottomClass: 'mx-0 h-full w-full text-left',
        }}
        stepPaths={[
                  Path.GUEST_SHOP_AND_DATE_SELECT,
                  Path.GUEST_CAR_INFO,
                  Path.GUEST_USER_INFO,
                ]}
        navigate={navigate}
        locationState={location.state}
      />
      <div className="mt-2 mb-4 flex flex-col items-center justify-center border border-line bg-background-sub px-2 py-3 sm:mt-20 sm:px-10">
        <div className="flex flex-col items-center">
          <div className="box-border flex flex-row items-center">
            <Icons.Image src={Icons.alert} alt="Alert" className="h-10 w-10" />
            <div className="notice-area mx-1 flex flex-row items-center">
              <span className="text-base mr-4 whitespace-nowrap font-bold">
                予約はまだ確定していません
              </span>
              <span className="text-sm">
                予約内容と注意事項を確認してください
              </span>
            </div>
          </div>
          <div className='mt-4'>
            <Linked
              text="注意事項の確認・予約確定へ進む"
              isLine={true}
              linkIcon={'R'}
              className="text-sm items-center justify-center self-center"
              onClick={() => scrollToBottom()}
            />
          </div>
        </div>
      </div>
      <div className="mt-12">
        <Proctitle
          useH1={true}
          text="STEP4 予約内容確認"
          className={{ textClass: 'whitespace-nowrap' }}
        />
      </div>
      <div className="mt-6 flex flex-col sm:flex-row sm:items-start">
        <h2 className="sm:w-40">予約日時</h2>
        <ul className="pl-4 text-left">
          <li>
            {`${dayjs(shopAndDateInfo.date).format('YYYY')}年${dayjs(
              shopAndDateInfo.date
            ).format('M')}月${dayjs(shopAndDateInfo.date).format('D')}日(${dayjs(
              shopAndDateInfo.date
            ).format('dd')}) ${shopAndDateInfo.time}`}
          </li>
        </ul>
      </div>
      <div className="mt-6 flex flex-col sm:flex-row sm:items-start">
        <h2 className="sm:w-40">予約店舗</h2>
        <ul className="mt-2 pl-4 text-left sm:mt-0">
          <li>{location.state?.shopAndDateInfo?.shop?.shopName}</li>
        </ul>
      </div>
      <div className="mt-6 border-t border-line sm:mx-0 sm:mt-8 sm:border-0"/>
      <div className="mt-6 flex flex-col sm:flex-row sm:items-start">
        <h2 className="sm:w-40">予約車両</h2>
        <ul className="mt-2 pl-4 text-left sm:mt-0">
          <li>
            {carInfo.manufacturer} {carInfo.carModel}
          </li>
          {carInfo.year && <li>年式：{carInfo.year}年</li>}
          {carInfo.mileage && (
            <li className="break-all">
              走行距離：
              {typeof carInfo.mileage === 'string'
                ? carInfo.mileage.replace(/(\d)(?=(\d{3})+$)/g, '$1,')
                : carInfo.mileage}
              km
            </li>
          )}
        </ul>
      </div>
      <div className="mt-6 border-t border-line sm:mx-0 sm:mt-4 sm:border-0"/>
      <div className="mt-6 flex flex-col sm:flex-row sm:items-start">
        <h2 className="sm:w-40">お名前</h2>
        <ul className="mt-2 pl-4 text-left sm:mt-0">
          <li className="break-all max-w-[300px]">
            {userInfo.lastName} {userInfo.firstName}
          </li>
        </ul>
      </div>
      <div className="mt-6 flex flex-col sm:flex-row sm:items-start">
        <h2 className="sm:w-40">フリガナ</h2>
        <ul className="mt-2 pl-4 text-left sm:mt-0">
          <li className="break-all max-w-[300px]">
            {userInfo.lastNameKana} {userInfo.firstNameKana}
          </li>
        </ul>
      </div>
      <div className="mt-6 flex flex-col sm:flex-row sm:items-start">
        <h2 className="sm:w-40">電話番号</h2>
        <ul className="mt-2 pl-4 text-left sm:mt-0">
          <li>{userInfo.phoneNumber}</li>
        </ul>
      </div>
      <div className="mt-6 flex flex-col sm:flex-row sm:items-start">
        <h2 className="sm:w-40">メールアドレス</h2>
        <ul className="mt-2 pl-4 text-left sm:mt-0">
          <li className="break-all max-w-[300px]">
            {userInfo.email}
          </li>
        </ul>
      </div>
      <div
        className="relative mt-6 border border-line bg-white sm:mt-16"
        id="caution"
      >
        <div className="flex h-11 items-center bg-background-itemName">
          <label className="text-sm ml-[16px] font-bold lg:ml-[30px]">
            【注意事項】
          </label>
        </div>
        <div className="scrollBar text-sm mb-4 ml-4 mr-2 mt-4 h-[306px] overflow-y-scroll bg-white pr-1 font-medium sm:h-[352px] sm:pr-3 lg:mb-8 lg:ml-8 lg:mr-5 lg:mt-8 lg:pr-2">
          <ul className="list-none pl-0">
            <li className="flex items-start mb-2">
              <span className="min-w-[1em]">1.</span>
              <span className="break-words">
                時間には余裕をもってご来店いただき、受付をお願い致します。<br />
                (開店時刻と同時刻にご予約いただいた場合は、開店時刻にて受付をお願いします。)
              </span>
            </li>
            <li className="flex items-start mb-2">
              <span className="min-w-[1em]">2.</span>
              <span className="break-words">
                ご予約のお時間に、連絡なくご来店いただけない場合はキャンセル扱いとさせていただきます。
              </span>
            </li>
            <li className="flex items-start mb-2">
              <span className="min-w-[1em]">3.</span>
              <span className="break-words">
                WEBからのキャンセルの受付は、作業予約日の前日１２時までとさせていただきます。以降は店舗に直接電話連絡をお願いいたします。
              </span>
            </li>
            <li className="flex items-start mb-2">
              <span className="min-w-[1em]">4.</span>
              <span className="break-words">
                ご予約の内容について、店舗より電話にて確認をさせていただく場合がございます。
              </span>
            </li>
            <li className="flex items-start mb-2">
              <span className="min-w-[1em]">5.</span>
              <span className="break-words">
                ご指定のメールアドレスに確認メールを送信いたしますが、念のため予約番号をお控えください。
              </span>
            </li>
            <li className="flex items-start mb-2">
              <span className="min-w-[1em]">6.</span>
              <span className="break-words">
                携帯メールのドメイン指定受信等（迷惑メール設定）をされている方は、以下のメールアドレスからの受信ができる様に、設定をお願いいたします。<br />
                送信元アドレス：rsv-info@autobacs.com
                ※設定を行わない場合、予約受付通知・前日のご案内などのメールが届かない場合がございます。
              </span>
            </li>
            <li className="flex items-start mb-2">
              <span className="min-w-[1em]">7.</span>
              <span className="break-words">
                不正改造車に対する作業はお断りする場合がございます。あらかじめご了承ください。
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div className="relative mt-4 flex items-center justify-center">
        <Checkbox
          formik={{
            values: { isTermsChecked },
            setFieldValue: () => setIsTermsChecked(prev => !prev),
            setFieldTouched: () => {},
          }}
          fieldName="isTermsChecked"
          text="注意事項を確認しました"
        />
      </div>
      <div className="mt-8 text-center">
        <AprosButton
          text="予約を確定する"
          comClassName="reserve"
          onClick={handleReserve}
          className="mb-4"
          disabled={!isTermsChecked}
        />
      </div>
      <div className="mt-8 mb-12 flex justify-center items-center text-center sm:mb-24">
        <Linked
          text="内容を修正する"
          onClick={() => navigate(Path.GUEST_USER_INFO, { state: location.state })}
          isLine
          linkIcon="L"
          className="font-bold"
        />
      </div>
      {error && (
        <ModalBase
          isOpen={error}
          onClose={() => setError(null)}
          title="エラー"
          description={error}
          buttonText="閉じる"
        />
      )}
      <div
        className={`fixed bottom-0 left-0 flex w-full flex-col items-center justify-center border-t border-solid border-[#d0d0d9] bg-white text-center transition-all duration-500 ease-in-out ${
          isBottomVisible ? 'h-[74px] opacity-100 sm:h-[87px]' : 'h-0 opacity-0'
        }`}
      >
        <div className="mb-[2px] mt-[-7px] flex flex-row items-center justify-center sm:mt-[-12px]">
          <Icons.Image
            src={Icons.alert}
            className="mt-2 h-6 w-6 sm:h-10 sm:w-10"
          />
          <label className="mt-2 text-[16px] font-bold sm:text-[24px]">
            予約はまだ確定していません
          </label>
        </div>
        <div>
          <Linked
            text="注意事項の確認・予約確定へ進む"
            isLine={true}
            linkIcon={'R'}
            className="text-sm items-center justify-center self-center"
            onClick={() => scrollToBottom()}
          />
        </div>
      </div>
      <div
        id="confirmbottom"
        className="float-left clear-both mb-[-1px] h-[1px] w-full"
      >
        &emsp;
      </div>
    </div>
  );
};

export default GuestConfirm;
